import * as yup from 'yup'
import { ShipmentStopUpdate, ShipmentUpdate } from 'apps/carrier/apiTypes/activeShipments'

interface ShipmentStopUpdateExtended extends ShipmentStopUpdate {
  hasLateReason: boolean
  hasRequiredEta: boolean
}

const INVALID_DATE = 'Invalid date'
const INVALID_TIME = 'Invalid time'

const invalidDateTest = yup
  .string()
  .nullable()
  .test('is-invalid', 'Please enter a valid date', val => val !== INVALID_DATE)
  .test('is-missing', 'Please enter missing time', val => val !== INVALID_TIME)

const ShipmentStopSchema = yup.object<ShipmentStopUpdateExtended>({
  manualEta: invalidDateTest.test(
    'is-required',
    'ETA is required for first pickup',
    function checkManualEtaRequired(val: string | null) {
      const parentContext: ShipmentStopUpdateExtended = this.parent as yup.TestContext['parent']
      // Manual eta check when there is no value entered
      // and shipment is the first pickup in 'assigned' state
      if (parentContext.hasRequiredEta && !val) {
        // Requirement error when there are 'Check In' or 'Check Out' input values
        return ![parentContext.arrivedAt, parentContext.leftAt].some(Boolean)
      }

      return true
    }
  ),
  hasRequiredEta: yup.boolean(),
  hasLateReason: yup.boolean(),
  lateReason: yup.string().when('hasLateReason', {
    is: true,
    then: yup.string().required('Late reason required'),
    otherwise: yup.string().notRequired(),
  }),
  arrivedAt: invalidDateTest,
  leftAt: invalidDateTest,
  trailerEmptiedAt: invalidDateTest,
})

export const ActiveShipmentsSchema = yup.object<ShipmentUpdate>({
  driverId: yup.number(),
  trailerNumber: yup.string().nullable(),
  truckNumber: yup.string().nullable(),
  vin: yup.string().min(4).max(6).nullable(),
  pickupsAttributes: yup.array().of(ShipmentStopSchema),
  deliveriesAttributes: yup.array().of(ShipmentStopSchema),
})

export type ActiveShipmentsSchemaType = yup.InferType<typeof ActiveShipmentsSchema>
